// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-on-homepage-only .table th {
  background-color: #366872 !important;
  /*Table Heading color property*/
  color: #ffffff !important;
  font-size: 12px !important;
}

.table-on-homepage-only .table tbody td {
  background-color: #ffffff !important;
  /*Table Body Background color (1) - S.NO */
  color: #333333 !important;
  font-size: 12px !important;
  /*Table Body Text size*/
}

/* Optional: row hover effect */
.table-on-homepage-only .table tbody tr:hover {
  background-color: #f1f1f1 !important;
}

.table-on-homepage-only .form-check label {
  cursor: pointer;
  /* margin-right: 10px; */
  color: #333333;
  /*Table Body Background color (2) Table Name*/
}

.table-on-homepage-only .department-dropdown-button {
  background-color: #366872 !important;
  color: var(--table-header-txt-color) !important;
  font-size: 12px !important;
  border-color: #2c5a63 !important;
}

/* Table List Department selection Dropdown*/

.table-on-homepage-only .department-dropdown-button-color {
  background-color: #fff;
  color: #000000;
  font-size: 12px
}

.table-on-homepage-only .table tbody tr.ifrs9-total-row td {
  background-color: #F7F5BC !important;
  color: #000000 !important;
  font-weight: bold;
}

.table-on-homepage-only .table tbody tr.ifrs9-header-row td {
  background-color: #f1f1f1 !important;
  font-weight: bold;
  text-transform: uppercase;
  color: #333 !important;
}



.table-on-homepage-only .dropdown-menu {
  --bs-dropdown-link-active-bg: #6c757d;
}

.table-on-homepage-only .pagination-container {
  font-family: 'Segoe UI', sans-serif;
}

.table-on-homepage-only .pagination-btn {
  border-radius: 50%;
  /* width: 32px; */
  /* smaller size */
  height: 32px;
  /* smaller size */
  background-color: transparent;
  color: #6c757d;
  /* Bootstrap's text-muted */
  font-weight: 400;
  /* normal font weight */
  border: none;
  padding: 0;
  transition: 0.2s;
}

.table-on-homepage-only .pagination-btn:hover {
  background-color: #f0f0ff;
}

.table-on-homepage-only .pagination-btn.active {
  background-color: #fff !important;
  color: #6c757d;
  font-weight: bold;
  font-weight: 500;
  /* width: 28px; */
  height: 28px;
  padding: 0;
}

.table-on-homepage-only .pagination-input {
  background-color: #e0e7ff;
  border: none;
  text-align: center;
  font-weight: bold;
  color: #6c757d;
}

.table-on-homepage-only .mt-half {
  margin-top: 0.5rem !important;
}

.table-on-homepage-only .table-name {
  color: #366872;
}

.table-on-homepage-only .total-number {
  color: #366872;
}

.table-on-homepage-only .dropdown-button-color {
  background-color: #366872;
  color: #e0e7ff;
}

.table-on-homepage-only .table-footer-details {
  background-color: #366872;
  position: sticky;
  bottom: 0;
  z-index: 1;
}

.table-on-homepage-only .table-footer-color {
  font-weight: bold !important;
  background-color: #366872 !important;
  color: var(--whitefont-color) !important;
  text-align: right !important;
  padding-right: 10px !important;
}

/* Override modal-dialog max-width */
.table-on-homepage-only .modal-dialog {
  max-width: 600px !important;
  /* or whatever width suits your layout */
  width: 90%;
}

/* Main table container (no column styles here) */
.table-on-homepage-only {
  width: 100%;
}

/* New custom table class with all existing styles plus column-specific styles for track changes report */
.custom-table-with-status-colors .table th {
  background-color: #366872 !important;
  color: #ffffff !important;
  font-size: 12px !important;
}

.custom-table-with-status-colors .table tbody td {
  background-color: #ffffff !important;
  color: #333333 !important;
  font-size: 12px !important;
}

/* Row hover effect */
.custom-table-with-status-colors .table tbody tr:hover {
  background-color: #f1f1f1 !important;
}

/* Column-specific status colors */
.custom-table-with-status-colors .table td.submitted-status {
  /* background-color: #e6f7ff !important; */
  color: #0056b3 !important;
}

.custom-table-with-status-colors .table td.rejected-status {
  /* background-color: #ffebee !important; */
  color: #c62828 !important;
}

.custom-table-with-status-colors .table td.modified-status {
  /* background-color: #fff3e0 !important; */
  color: #e65100 !important;
}

.custom-table-with-status-colors .table td.approved-status {
  /* background-color: #e8f5e9 !important; */
  color: #2e7d32 !important;
}

/* Keep all the other existing styles from .table-on-homepage-only */
.custom-table-with-status-colors .form-check label {
  cursor: pointer;
  color: #333333;
}

.custom-table-with-status-colors .department-dropdown-button {
  background-color: #366872 !important;
  color: var(--table-header-txt-color) !important;
  font-size: 12px !important;
  border-color: #2c5a63 !important;
}

.table-loading-top {
  position: absolute;
  top: -25px;
  /* adjust as needed */
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.text-small {
  font-size: 0.8rem;
  /* Adjust this value as needed */
}



button.btn-download {
  background-color: var(--download-btn-bg-color);
  color: var(--download-btn-txt-color);
  box-shadow: var(--button-box-shadow);
}

/* button.btn-download:hover {
    background-color: var(--download-btn-bg-color);
    color: var(--whitefont-color);
  } */

button.btn-download:hover,
button.btn-download:active,
button.btn-download:focus {
  background-color: var(--download-btn-bg-color) !important;
  color: var(--download-btn-txt-color) !important;
  border-color: var(--download-btn-bg-color) !important;
  /* Optional */
  box-shadow: none !important;
  /* Optional: removes Bootstrap glow */
}


.custom-btn {
  width: 100px;
  /* Adjust width as needed */
  /* Add any other styling you want for the buttons */
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid #6c757d;
}


.template-text {
  padding: 10px 0;
}

.template-icon {
  /* background-color: #004f8b; */
  background: linear-gradient(45deg, #07beb8, #967aa1);
  /* padding: 5px 0; */
  color: white;
  border-top: 1px solid white;
  border-radius: 0 0 10px 10px;
  position: relative;
  margin-top: 30px;
  /* pushes the whole blue section down */
}

.template-icon2 {
  /* background-color: #c9832f; */
  background: linear-gradient(45deg, #f25c54, #967aa1);
  /* padding: 5px 0; */
  color: white;
  border-top: 1px solid white;
  border-radius: 0 0 10px 10px;
  position: relative;
  margin-top: 30px;
  /* pushes the whole blue section down */
}

.template-icon3 {
  /* background-color: #5f35b0; */
  background: linear-gradient(45deg, #133c55, #967aa1);
  /* padding: 5px 0; */
  color: white;
  border-top: 1px solid white;
  border-radius: 0 0 10px 10px;
  position: relative;
  margin-top: 30px;
  /* pushes the whole blue section down */
}

.template-icon i {
  font-size: 18px;
  border: 2px solid white;
  border-radius: 50%;
  padding: 8px 10px;
  /* background-color: #004f8b; */
  background: linear-gradient(45deg, #07beb8, #967aa1);
  position: relative;
  top: -20px;
}

.template-icon2 i {
  font-size: 18px;
  border: 2px solid white;
  border-radius: 50%;
  padding: 8px 10px;
  /* background-color: #c9832f; */
  background: linear-gradient(45deg, #f25c54, #967aa1);
  position: relative;
  top: -20px;
}

.template-icon3 i {
  font-size: 18px;
  border: 2px solid white;
  border-radius: 50%;
  transform: rotate(10deg) scale(1.1);
  padding: 8px 10px;
  /* background-color: #5f35b0; */
  background: linear-gradient(45deg, #133c55, #967aa1);
  position: relative;
  top: -20px;
}

.org-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.role-box {
  border: 2px solid #4285f4;
  border-radius: 10px;
  padding: 10px 15px;
  width: 180px;
  text-align: center;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 5px;
  background-color: #f0f0f0;
}

.avatar-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.connector-vertical {
  width: 2px;
  height: 20px;
  background-color: #ccc;
  margin: 5px 0;
}

.makers-row {
  gap: 30px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Tableproperty.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,4CAA4C;;AAE5C;EACE,sBAAsB;EACtB,cAAc;EACd;AACF;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;;;AAIA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,WAAW;AACb;;AAEA,yGAAyG;AACzG;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;;;AAIA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;KAGK;;AAEL;;;EAGE,yDAAyD;EACzD,+CAA+C;EAC/C,qDAAqD;EACrD,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;AACvC;;;AAGA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;AAChC;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,+BAA+B;EAC/B,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".table-on-homepage-only .table th {\r\n  background-color: #366872 !important;\r\n  /*Table Heading color property*/\r\n  color: #ffffff !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.table-on-homepage-only .table tbody td {\r\n  background-color: #ffffff !important;\r\n  /*Table Body Background color (1) - S.NO */\r\n  color: #333333 !important;\r\n  font-size: 12px !important;\r\n  /*Table Body Text size*/\r\n}\r\n\r\n/* Optional: row hover effect */\r\n.table-on-homepage-only .table tbody tr:hover {\r\n  background-color: #f1f1f1 !important;\r\n}\r\n\r\n.table-on-homepage-only .form-check label {\r\n  cursor: pointer;\r\n  /* margin-right: 10px; */\r\n  color: #333333;\r\n  /*Table Body Background color (2) Table Name*/\r\n}\r\n\r\n.table-on-homepage-only .department-dropdown-button {\r\n  background-color: #366872 !important;\r\n  color: var(--table-header-txt-color) !important;\r\n  font-size: 12px !important;\r\n  border-color: #2c5a63 !important;\r\n}\r\n\r\n/* Table List Department selection Dropdown*/\r\n\r\n.table-on-homepage-only .department-dropdown-button-color {\r\n  background-color: #fff;\r\n  color: #000000;\r\n  font-size: 12px\r\n}\r\n\r\n.table-on-homepage-only .table tbody tr.ifrs9-total-row td {\r\n  background-color: #F7F5BC !important;\r\n  color: #000000 !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.table-on-homepage-only .table tbody tr.ifrs9-header-row td {\r\n  background-color: #f1f1f1 !important;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  color: #333 !important;\r\n}\r\n\r\n\r\n\r\n.table-on-homepage-only .dropdown-menu {\r\n  --bs-dropdown-link-active-bg: #6c757d;\r\n}\r\n\r\n.table-on-homepage-only .pagination-container {\r\n  font-family: 'Segoe UI', sans-serif;\r\n}\r\n\r\n.table-on-homepage-only .pagination-btn {\r\n  border-radius: 50%;\r\n  /* width: 32px; */\r\n  /* smaller size */\r\n  height: 32px;\r\n  /* smaller size */\r\n  background-color: transparent;\r\n  color: #6c757d;\r\n  /* Bootstrap's text-muted */\r\n  font-weight: 400;\r\n  /* normal font weight */\r\n  border: none;\r\n  padding: 0;\r\n  transition: 0.2s;\r\n}\r\n\r\n.table-on-homepage-only .pagination-btn:hover {\r\n  background-color: #f0f0ff;\r\n}\r\n\r\n.table-on-homepage-only .pagination-btn.active {\r\n  background-color: #fff !important;\r\n  color: #6c757d;\r\n  font-weight: bold;\r\n  font-weight: 500;\r\n  /* width: 28px; */\r\n  height: 28px;\r\n  padding: 0;\r\n}\r\n\r\n.table-on-homepage-only .pagination-input {\r\n  background-color: #e0e7ff;\r\n  border: none;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  color: #6c757d;\r\n}\r\n\r\n.table-on-homepage-only .mt-half {\r\n  margin-top: 0.5rem !important;\r\n}\r\n\r\n.table-on-homepage-only .table-name {\r\n  color: #366872;\r\n}\r\n\r\n.table-on-homepage-only .total-number {\r\n  color: #366872;\r\n}\r\n\r\n.table-on-homepage-only .dropdown-button-color {\r\n  background-color: #366872;\r\n  color: #e0e7ff;\r\n}\r\n\r\n.table-on-homepage-only .table-footer-details {\r\n  background-color: #366872;\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.table-on-homepage-only .table-footer-color {\r\n  font-weight: bold !important;\r\n  background-color: #366872 !important;\r\n  color: var(--whitefont-color) !important;\r\n  text-align: right !important;\r\n  padding-right: 10px !important;\r\n}\r\n\r\n/* Override modal-dialog max-width */\r\n.table-on-homepage-only .modal-dialog {\r\n  max-width: 600px !important;\r\n  /* or whatever width suits your layout */\r\n  width: 90%;\r\n}\r\n\r\n/* Main table container (no column styles here) */\r\n.table-on-homepage-only {\r\n  width: 100%;\r\n}\r\n\r\n/* New custom table class with all existing styles plus column-specific styles for track changes report */\r\n.custom-table-with-status-colors .table th {\r\n  background-color: #366872 !important;\r\n  color: #ffffff !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.custom-table-with-status-colors .table tbody td {\r\n  background-color: #ffffff !important;\r\n  color: #333333 !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n/* Row hover effect */\r\n.custom-table-with-status-colors .table tbody tr:hover {\r\n  background-color: #f1f1f1 !important;\r\n}\r\n\r\n/* Column-specific status colors */\r\n.custom-table-with-status-colors .table td.submitted-status {\r\n  /* background-color: #e6f7ff !important; */\r\n  color: #0056b3 !important;\r\n}\r\n\r\n.custom-table-with-status-colors .table td.rejected-status {\r\n  /* background-color: #ffebee !important; */\r\n  color: #c62828 !important;\r\n}\r\n\r\n.custom-table-with-status-colors .table td.modified-status {\r\n  /* background-color: #fff3e0 !important; */\r\n  color: #e65100 !important;\r\n}\r\n\r\n.custom-table-with-status-colors .table td.approved-status {\r\n  /* background-color: #e8f5e9 !important; */\r\n  color: #2e7d32 !important;\r\n}\r\n\r\n/* Keep all the other existing styles from .table-on-homepage-only */\r\n.custom-table-with-status-colors .form-check label {\r\n  cursor: pointer;\r\n  color: #333333;\r\n}\r\n\r\n.custom-table-with-status-colors .department-dropdown-button {\r\n  background-color: #366872 !important;\r\n  color: var(--table-header-txt-color) !important;\r\n  font-size: 12px !important;\r\n  border-color: #2c5a63 !important;\r\n}\r\n\r\n.table-loading-top {\r\n  position: absolute;\r\n  top: -25px;\r\n  /* adjust as needed */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 10;\r\n}\r\n\r\n.text-small {\r\n  font-size: 0.8rem;\r\n  /* Adjust this value as needed */\r\n}\r\n\r\n\r\n\r\nbutton.btn-download {\r\n  background-color: var(--download-btn-bg-color);\r\n  color: var(--download-btn-txt-color);\r\n  box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-download:hover {\r\n    background-color: var(--download-btn-bg-color);\r\n    color: var(--whitefont-color);\r\n  } */\r\n\r\nbutton.btn-download:hover,\r\nbutton.btn-download:active,\r\nbutton.btn-download:focus {\r\n  background-color: var(--download-btn-bg-color) !important;\r\n  color: var(--download-btn-txt-color) !important;\r\n  border-color: var(--download-btn-bg-color) !important;\r\n  /* Optional */\r\n  box-shadow: none !important;\r\n  /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n.custom-btn {\r\n  width: 100px;\r\n  /* Adjust width as needed */\r\n  /* Add any other styling you want for the buttons */\r\n}\r\n\r\n.arrow-down {\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-top: 10px solid #6c757d;\r\n}\r\n\r\n\r\n.template-text {\r\n  padding: 10px 0;\r\n}\r\n\r\n.template-icon {\r\n  /* background-color: #004f8b; */\r\n  background: linear-gradient(45deg, #07beb8, #967aa1);\r\n  /* padding: 5px 0; */\r\n  color: white;\r\n  border-top: 1px solid white;\r\n  border-radius: 0 0 10px 10px;\r\n  position: relative;\r\n  margin-top: 30px;\r\n  /* pushes the whole blue section down */\r\n}\r\n\r\n.template-icon2 {\r\n  /* background-color: #c9832f; */\r\n  background: linear-gradient(45deg, #f25c54, #967aa1);\r\n  /* padding: 5px 0; */\r\n  color: white;\r\n  border-top: 1px solid white;\r\n  border-radius: 0 0 10px 10px;\r\n  position: relative;\r\n  margin-top: 30px;\r\n  /* pushes the whole blue section down */\r\n}\r\n\r\n.template-icon3 {\r\n  /* background-color: #5f35b0; */\r\n  background: linear-gradient(45deg, #133c55, #967aa1);\r\n  /* padding: 5px 0; */\r\n  color: white;\r\n  border-top: 1px solid white;\r\n  border-radius: 0 0 10px 10px;\r\n  position: relative;\r\n  margin-top: 30px;\r\n  /* pushes the whole blue section down */\r\n}\r\n\r\n.template-icon i {\r\n  font-size: 18px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n  padding: 8px 10px;\r\n  /* background-color: #004f8b; */\r\n  background: linear-gradient(45deg, #07beb8, #967aa1);\r\n  position: relative;\r\n  top: -20px;\r\n}\r\n\r\n.template-icon2 i {\r\n  font-size: 18px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n  padding: 8px 10px;\r\n  /* background-color: #c9832f; */\r\n  background: linear-gradient(45deg, #f25c54, #967aa1);\r\n  position: relative;\r\n  top: -20px;\r\n}\r\n\r\n.template-icon3 i {\r\n  font-size: 18px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n  transform: rotate(10deg) scale(1.1);\r\n  padding: 8px 10px;\r\n  /* background-color: #5f35b0; */\r\n  background: linear-gradient(45deg, #133c55, #967aa1);\r\n  position: relative;\r\n  top: -20px;\r\n}\r\n\r\n.org-chart-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.role-box {\r\n  border: 2px solid #4285f4;\r\n  border-radius: 10px;\r\n  padding: 10px 15px;\r\n  width: 180px;\r\n  text-align: center;\r\n  background-color: white;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.avatar-circle {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n  margin: 0 auto 5px;\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.avatar-circle img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.connector-vertical {\r\n  width: 2px;\r\n  height: 20px;\r\n  background-color: #ccc;\r\n  margin: 5px 0;\r\n}\r\n\r\n.makers-row {\r\n  gap: 30px;\r\n  margin-top: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
